import {loadRoute} from './route-components.jsx';
import React from 'react';
import {hydrateRoot} from 'react-dom/client';
import App from './App.jsx';
import './styles.css';
import './theme-tokens.css';
import './ui/ui.css';
import './brand.css';
import './platform.css';
import './home2.css';
import './experience.css';
import './pdf-tools/pdf-platform.css';
import './blog-futuristic.css';
import './future-design.css';
import './fonts.css';
const data=JSON.parse(document.getElementById('initial-data').textContent);
loadRoute(data).then(()=>hydrateRoot(document.getElementById('root'),<App data={data}/>));
